module.exports = __webpack_public_path__ + "static/img/05.9181e071.png";